module.exports = __webpack_public_path__ + "img/36760db.svg";